import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import cardboard from '../../json/cardboard-recycling-data.json'

const cardboardServiceData = {
  name: 'Cardboard Pickup and Recycling Services',
  description:
    'Nationwide cardboard pickup and recycling for businesses and households. Dimension collects flattened and unflattened boxes, stacks, pallets, and bales, prices by volume, and recycles every load with a waste diversion report.',
  serviceType: 'Cardboard Recycling',
  url: 'https://getdimension.com/cardboard-recycling',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Cardboard Box Recycling' },
    { name: 'Box Removal' },
    { name: 'Baled and Palletized Cardboard Pickup' },
    { name: 'Recurring Commercial Cardboard Collection' },
  ],
}

const cardboardFAQData = {
  questions: cardboard.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function CardboardRecycling() {
  return (
    <>
      <Head>
        <title>Cardboard Pickup and Recycling Services | Dimension</title>
        <meta
          name="description"
          content="Nationwide cardboard pickup and recycling for businesses and homes. Boxes, stacks, pallets, and bales collected and recycled, priced by volume from around $79."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/cardboard-recycling" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={cardboardServiceData} />
        <SchemaMarkup type="FAQPage" data={cardboardFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={cardboard.pitch.heading}
          material={cardboard.pitch.material}
          pitchText={cardboard.pitch.pitchText}
          ctaLink={cardboard.pitch.ctaLink}
          ctaText={cardboard.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...cardboard.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...cardboard.benefits} />
        <CaseStudy {...cardboard.caseStudy} />
        <Approach {...cardboard.approach} />
        <FAQ {...cardboard.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Pallet Disposal',
              href: '/pallet-disposal',
              description:
                'Wood, plastic, and metal pallet pickup and recycling — the other half of most warehouse waste.',
            },
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'Roll-off containers from 5 to 40 yards, with cardboard carrying no material surcharge.',
            },
            {
              label: 'General Waste Disposal',
              href: '/general-waste-disposal',
              description:
                'Recurring and one-time collection of everyday trash and mixed recyclables for homes and businesses.',
            },
            {
              label: 'Junk Removal Services',
              href: '/junk-removal',
              description:
                'Full-service removal of furniture, appliances, electronics, and complete cleanouts nationwide.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default CardboardRecycling
